<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('businessTransferDetails.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-2 almarai-bold" aria-current="page">
              {{$t('businessTransferDetails.breadcrumb_2')}}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" />
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row pt-3">
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-12 text-center algin-content-center">
            <swiper v-if="ExchangeMedia.length" :modules="modules" :pagination="{ clickable: true }" :spaceBetween="10"
              :thumbs="{ swiper: thumbsSwiper }" :navigation="true" :autoplay="{ delay: 2500, disableOnInteraction: false,}"
              :style="{'--swiper-navigation-color': '#fff','--swiper-pagination-color': '#fff',}" class="br-radius"
            >
              <swiper-slide style="position:relative" v-for="(picture, index) in ExchangeMedia" :key="index">
                <!-- <span class="favorite" v-if="row.Favorites && row.Favorites.length" @click.prevent="removeFavorite(row.id, 'row.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon-remove"></i>
                </span>
                <span  class="favorite" v-else @click.prevent="addFavorite(row.id, 'row.mediaFiles', index)">
                  <i class="fa-solid fa-heart favorite-icon"></i>
                </span> -->
                <img :src="MEDIA_URL+picture.filePath" @click="openLightbox(index)" alt="Slide Image" class="swiper-img" />
              </swiper-slide>
            </swiper>
            <div v-else>
              <placeHolder />
            </div>

            <FsLightbox
              :toggler="lightboxToggler"
              :sources="images"
              :slide="lightboxIndex + 1"
            />

            <swiper v-if="ExchangeMedia.length" @swiper="setThumbsSwiper" :spaceBetween="10" :slidesPerView="4" 
              :freeMode="true"
              :watchSlidesProgress="true"
              :modules="modules"
              class="pt-3 mouse-hand"
            >
              <swiper-slide v-for="(i,indx) in ExchangeMedia" :key="indx">
                <img :src="MEDIA_URL+i.thumbnail" class="img-fluid br-radius" alt="">
              </swiper-slide>
            </swiper>
            <div v-else class="pt-3 text-end">
              <img src="/assets/images/placeHolder.jpeg" class="style-img" alt="" />
            </div>
          </div>
        </div>
        <hr class="line-color">
        <div class="row">
          <div class="col button-center">
            <div class="almarai-bold dierction">{{row.description}}</div>
            <div class="gray-color d-flex fonttext-14 pt-2">
              <i class="fa-solid fa-location-dot"></i>
              <div class="mx-2">{{row.City.name}}</div>
              <div>{{row.Neighborhood.name}}</div>
            </div>
          </div>
          <div class="col-auto text-center">
            <div class="bg-green-2B">{{statusChoices[row.status]}}</div>
          </div>
        </div>
        <div class="row pt-4">
          <div class="col">
            <h5 class="almarai-bold font-20">{{$t('businessTransferDetails.Advertisementdetails')}}</h5>
          </div>
        </div>
        <div class="row">
          <div class="col gray-color-60">
            <div>{{$t('businessTransferDetails.ActivityDescription')}}</div>
            <div>{{row.description}}</div>

            <div class="pt-2">{{$t('businessTransferDetails.Reason')}}</div>
            <div>{{row.ExchangeReason.name}}</div>

            <div class="pt-2">{{$t('businessTransferDetails.assetsList')}}</div>
            <ul class="assetsList">
              <li>
                <div>{{$t('businessTransferDetails.listofassets')}}</div>
                <div>{{row.assetsList}}</div>
              </li>
              <li v-if="row.ExchangeAsset">
                <div>{{$t('businessTransferDetails.FixedAsset')}}</div>
                {{row.ExchangeAsset.name}}
              </li>
              <li>
                <div>{{$t('businessTransferDetails.financialObligations')}}</div>
                <div v-if="row.hasDebts == true">{{$t('addAd.yes')}}</div>
                <div v-else>{{$t('addAd.no')}}</div>
              </li>
            </ul>

            <div v-if="ExchangeStrengths.length" class="pt-2">
              <div class="almarai-bold">{{$t('businessTransferDetails.ProjectStrengths')}}</div>
              <div class="row pt-3">
                <div class="col-auto mx-1 d-flex bg-green-2B" v-for="(strengths,index) in ExchangeStrengths" :key="index">
                  {{strengths.name}}
                </div>
              </div>
            </div>

            <div v-if="ExchangeWeaknesses.length" class="pt-4">
              <div class="almarai-bold">{{$t('businessTransferDetails.projectWeaknesses')}}</div>
              <div class="row pt-3">
                <div class="col-auto mx-1 d-flex bg-red-1B" v-for="(weakness,index) in ExchangeWeaknesses" :key="index">
                  {{weakness.name}}
                </div>
              </div>
            </div>

            <!-- <div class="pt-3">نقاط ضعف المشروع</div> -->
            <div class="row pt-4 justify-content-center">
              <div class="col-12 col-md-6">
                <div class="row mx-2 pt-2" v-if="row.Age.name">
                  <div class="weaknesses">
                    <div class="col-6">{{$t('businessTransferDetails.projectAge')}}</div>
                    <div class="col-6 text-direction">{{row.Age.name}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.area">
                  <div class="bg-color-beige d-flex">
                    <div class="col-6">{{$t('businessTransferDetails.projectArea')}}</div>
                    <div class="col-6 text-direction">{{row.area}} <span>{{$t('businessTransferDetails.square')}}</span></div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.ProjectAge.name">
                  <div class="weaknesses">
                    <div class="col-6 space">{{$t('businessTransferDetails.remainingTerm')}}</div>
                    <!-- <div class="col-6 text-direction">{{row.ageId}}</div> -->
                    <div class="col-6 text-direction">{{row.ProjectAge.name}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.floorsCount">
                  <div class="bg-color-beige d-flex">
                    <div class="col-6">{{$t('businessTransferDetails.floorsCount')}}</div>
                    <div class="col-6 text-direction">{{row.floorsCount}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.officesCount">
                  <div class="weaknesses">
                    <div class="col-6">{{$t('businessTransferDetails.officesCount')}}</div>
                    <div class="col-6 text-direction">{{row.officesCount}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.hallsCount">
                  <div class="bg-color-beige d-flex">
                    <div class="col-6">{{$t('businessTransferDetails.hallsCount')}}</div>
                    <div class="col-6 text-direction">{{row.hallsCount}}</div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 efmadfsjkdf">
                <div class="row mx-2 pt-2" v-if="row.ExchangeFront.name">
                  <div class="bg-color-beige d-flex">
                    <div class="col-6">{{$t('businessTransferDetails.View')}}</div>
                    <div class="col-6 text-direction">{{row.ExchangeFront.name}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.doorsCount">
                  <div class="weaknesses">
                    <div class="col-6">{{$t('businessTransferDetails.doorsCount')}}</div>
                    <div class="col-6 text-direction">{{row.doorsCount}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.roomsCount">
                  <div class="bg-color-beige d-flex">
                    <div class="col-6">{{$t('businessTransferDetails.roomsCount')}}</div>
                    <div class="col-6 text-direction">{{row.roomsCount}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.bathroomsCount">
                  <div class="weaknesses">
                    <div class="col-6">{{$t('businessTransferDetails.bathroomsCount')}}</div>
                    <div class="col-6 text-direction">{{row.bathroomsCount}}</div>
                  </div>
                </div>

                <div class="row mx-2 pt-2" v-if="row.parkingCount">
                  <div class="weaknesses bg-color-beige">
                    <div class="col-6">{{$t('businessTransferDetails.parkingCount')}}</div>
                    <div class="col-6 text-direction">{{row.parkingCount}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-3">
              <div class="col">
                <div class="row">
                  <div class="almarai-bold">{{$t('businessTransferDetails.applicant')}}</div>
                  <div class="col-auto">
                    <i class="fa-solid mouse-hand fa-circle-user logoProfile width-48"></i>
                  </div>
                  <div class="col-auto px-0 userName" v-if="row.name">
                    {{row.name}}
                  </div>
                </div>
              </div>
              <div v-if="!isOwner" class="col-auto content-center d-none d-md-block">
                <router-link to="/login" v-if="!GET_USER" class="chatWithClient mx-2"><i class="fa-regular fa-comment-dots mx-2"></i> {{ $t('nav.chatWithClient') }}</router-link>
                <button v-if="GET_USER" :disabled="sendChatDisabled" class="chatWithClient" @click.prevent="sendChatMessage"><i class="fa-regular fa-comment-dots mx-2"></i> {{ $t('nav.chatWithClient') }}</button>
              </div>
              <div class="col-auto px-2 content-center">
                <div class="row justify-content-end">
                  <div class="col-auto ps-0" v-if="GET_USER">
                    <a :href="`https://wa.me/${row.mobile}`+'?text=السلام عليكم وجدت إعلانكم في تطبيق عقار المحيسني وأرغب بالتواصل معكم بخصوص الإعلان:'+
                      ' '+row.description +' '+ row.City.name+' '+row.Neighborhood.name+' '+'https://aqaralmuhaysini.com/businessTransfer/'+row.id
                      " target="_blank"
                    >
                      <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                    </a>
                  </div>
                  <div v-else @click="poupLogin" class="col-auto ps-0 mouse-hand">
                    <img src="/assets/images/icons/whatsApp-icon.png" class="width-48" alt="">
                  </div>
                  <div class="col-auto">
                    <a :href="`tel:${row.mobile}`" target="_blank">
                      <img src="/assets/images/icons/phoneNumber.png" class="width-48" alt="">
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center" v-if="!isOwner">
            <div class="col-11 content-center d-block d-md-none chatWithClient">
              <router-link to="/login" v-if="!GET_USER" class="green-color-2BB"><i class="fa-regular fa-comment-dots mx-2"></i> {{ $t('nav.chatWithClient') }}</router-link>
              <div v-if="GET_USER" :disabled="sendChatDisabled" class=" " @click.prevent="sendChatMessage"><i class="fa-regular fa-comment-dots mx-2"></i> {{ $t('nav.chatWithClient') }}</div>
            </div>
          </div>
          </div>
        </div>
        <!--begin:location-->
        <div class="row py-3" v-if="!isLoading && row.latitude && row.longitude">
          <div class="col">
            <div class="almarai-bold py-2">{{$t('propertydetails.title_14')}}</div>
            <div ref="myMap" style="width: 100%; height: 350px;"></div>
          </div>
        </div>
        <!--end:location-->

        <div class="row justify-content-center py-2">
          <div class="col-6 col-md-6 text-center content-center">
            <a :href="`https://wa.me/+966920016962?text=${customer_ServiceMessage}${encodeURIComponent(whatsAppTextPublic)}`" target="_blank">
              <div class="card contactService">
                <div class="card-body">
                  <div class="d-block d-md-none">
                    <img src="/assets/images/icons/call-calling.png" alt="">
                  </div>
                  <span class="d-none d-md-block">
                    <img src="/assets/images/icons/call-calling.png" alt="">
                    <span class="mx-2">{{$t('contactService')}} {{$t('customers')}}</span>
                  </span>
                  <div class="d-block d-md-none">{{$t('contactService')}} {{$t('customers')}}</div>
                </div>
              </div>
            </a>
          </div>
          <div  class="col-6 col-md-6">
            <router-link :to="'/lawyerRequested/'+B_TransferID+'?propertyType=exchange'">
              <div class="card contactLawyer">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <div class="col-auto d-block d-md-none content-center text-center">
                      <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                    </div>
                    <div class="almarai-bold d-block d-md-none">{{$t('contactLawyer')}}</div>
                    <span class="d-none lawyer-style d-md-block">
                      <img src="/assets/images/icons/lawyer-icon.png" class="lawyer-logo" alt="">
                      <span class="mx-2">{{$t('contactLawyer')}}</span>
                    </span>
                    <!-- <div class="col-8 content-center">
                      <div v-if="!isFree && !isOwner"> 
                        <span>{{$t('lawyerNow')}}</span>
                        <span class="mx-1 almarai-bold green-color-F">{{lawyerPrice}}</span> 
                        <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span> 
                      </div>
                    </div>
                    <div class="col-auto button-center ps-0">
                      <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
                      <i v-else class="fa-solid fa-chevron-right pt-1"></i>
                    </div> -->
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="row justify-content-center pt-4">
          <div class="col">
            <div class="card shadow-card">
              <div class="card-body">
                <div class="row justify-content-around">
                  <div v-if="row.price !=0" class="col-12 col-md-6 content-center">
                    <div class="row">
                      <div class="col almarai-bold content-center">
                        {{$t('businessTransferDetails.totalPrice')}}
                      </div>
                      <div class="col-auto almarai-bold">
                        {{row.price}} <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 btn-black reservation_button">
                    <router-link :to="'/propertypreview/'+B_TransferID+'?model=exchange'">
                      <div class="text-white">{{$t('businessTransferDetails.reservePreview')}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formLogin">
      <div class="modal-dialog modal-Max320">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto mouse-hand" @click.prevent="closeingFN">
                <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="loginTitle">
                  {{$t("formLogin.title_1")}}
                </div>
                <p class="fontGray-73 mb-1 pt-1">
                  {{$t("formLogin.title_2")}} <br />
                  {{$t("formLogin.title_3")}}
                </p>
              </div>
            </div>
            <div class="row pt-3 justify-content-center">
              <div class="col-11 col-md-8 mb-2">
                <router-link to="/login">
                  <button class="form-control btn-green">
                    {{$t("formLogin.title_4")}}
                  </button>
                </router-link>
              </div>
              <div class="col-11 col-md-8 pt-1">
                <router-link to="/register">
                  <button class="form-control btn-black">
                    {{ $t("formLogin.title_5") }}
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->

    <!--begin:modalPropertyreservation-->
    <!-- <div class="modal bg-modal" tabindex="-1" id="modalreservation">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="" dir="ltr">
            <button type="button" @click="closeForm" class="btn-close p-3" data-bs-dismiss="modal" aria-label="Close"></button>
            <h5 class="modal-title text-center font-24 almarai-bold">{{$t('propertydetails.title_11')}}</h5>
          </div>
          <div class="modal-body text-center">
            <div class="row">
              <div class="col almarai-regular gray-color">
                <div>{{$t('propertydetails.title_21')}}</div>
                <div>{{$t('propertydetails.title_22')}}</div>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col almarai-regular gray-color">
                <div>{{$t('propertydetails.title_23')}}</div>
                <div>{{$t('propertydetails.title_24')}}</div>
              </div>
            </div>
          </div>
          <div class="row py-3 justify-content-center">
            <div class="col-10" v-if="!isLoading">
              <router-link :to="'/propertyreservation/'+B_TransferID">
              <div class="submit-button text-center">{{$t('propertydetails.title_11')}}</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!--end:modalPropertyreservation-->
  </div>
</template>

<script>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import { Pagination, Navigation, FreeMode, Thumbs, Autoplay } from "swiper/modules";
import { mapGetters } from "vuex";
import FsLightbox from "fslightbox-vue";
import { toast } from '@/helpers/tools';

export default {
  name:"businessTransfer",
  components: { Swiper, SwiperSlide,FsLightbox },
  computed:{
    ...mapGetters(["GET_USER",'MEDIA_URL', 'CHAT_CLIENT','FRONTEND_URL'])
  },
  setup(){
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    return {
      thumbsSwiper,
      setThumbsSwiper,
      modules: [FreeMode, Thumbs, Navigation, Pagination, Autoplay],
    }
  },
  data(){
    return {  
      B_TransferID: this.$route.params.id,
      propertyType: this.$route.query.propertyType ?? 'exchange',
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: true,
      ExchangeMedia: [],
      row:{},
      statusChoices: {},
      ExchangeStrengths: [],
      ExchangeWeaknesses: [],
      map: null,
      marker: null,
      icons: {},
      images:[],
      lightboxToggler: false,
      lightboxIndex: 0,
      lawyerPrice: null,
      isFree: null,
      userLang: 'ar',
      isOwner: false,
      sendChatDisabled: false,
      customer_ServiceMessage: this.$t('customer_ServiceMessage'),
      whatsAppTextPublic: null,
    }
  },
  
  methods: {
    getRetrieve(){
      this.hasError = false;
      this.$http.get("/api/exchanges/retrieve/"+this.B_TransferID).then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.ExchangeStrengths = res.data.row.ExchangeStrengths;
        this.statusChoices = res.data.statusChoices;
        this.ExchangeMedia = res.data.row.ExchangeMedia;
        this.ExchangeWeaknesses = res.data.row.ExchangeWeaknesses;
        this.icons = res.data.countedIcons;
        this.isOwner = res.data.isOwner;
        this.whatsAppTextPublic = `${this.FRONTEND_URL}/propertydetails/${this.$route.params.id}?propertyType=exchange&v=1 
        ${res.data.row.businessName}
        ${res.data.row.Region?.name} ${res.data.row.City?.name} 
        ${(res.data.row.price)? 'السعر '+res.data.row.price : ''}`;
        if(this.row.latitude && this.row.longitude){
          this.initialGoogleMap();
        }
        if(res.data.row.ExchangeMedia){
          for(let i=0; i < res.data.row.ExchangeMedia.length; i++){
            this.images.push(this.MEDIA_URL+res.data.row.ExchangeMedia[i].filePath);
          }
        }
        if(this.GET_USER && !this.isOwner)
          this.lawyerRequestPrice();
        window.scroll(0,0);
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        this.message = this.$globalError(err);
        this.hasError = true;
      })
    },

    openLightbox(index) {
      this.lightboxIndex = index;
      this.lightboxToggler = !this.lightboxToggler; // Toggle to open
    },

    reservation(){
      if(!this.GET_USER) {
        document.getElementById("formLogin").style.display = "block";
        return false;
      }else {
        this.$router.push({ path:"/propertypreview/"+this.B_TransferID });
      }
    },

    closeingFN() {
      document.getElementById("formLogin").style.display = "none";
    },

    poupLogin(){
      document.getElementById("formLogin").style.display = "block";
    },

    initMap(){
      if (!this.$refs.myMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }
      // Initialize Map
      this.map = new google.maps.Map(this.$refs.myMap, {
        center: { 
          lat: (this.row.latitude) ? parseFloat(this.row.latitude) :24.7136, 
          lng: (this.row.longitude) ? parseFloat(this.row.longitude) : 46.6753, 
        },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { 
          lat: (this.row.latitude)? parseFloat(this.row.latitude) : 24.7136, 
          lng: (this.row.longitude) ? parseFloat(this.row.longitude) : 46.6753 
        },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
        // console.log(parseFloat(this.row.latitude));
    },

    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script .src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCmKIguViZj4DtgCcT2Wv8pstx0ynuHMWg&loading=async&libraries=places&callback=initMap`
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    propertyReservation(){
      document.getElementById('modalreservation').style.display = 'block';
    },
    closeForm(){
      document.getElementById('modalreservation').style.display ='none';
    },

    addFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.$http.post("/api/favorites/add",{
        B_TransferID: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'row.mediaFiles'){
          this.row.Favorites = [{}];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      this.hasError = false;
      if(!this.GET_USER){
        document.getElementById('formLogin').style.display = "block";
        return false;
      }
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'row.mediaFiles'){
          this.row.Favorites = [];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    lawyerRequestPrice(){
      this.hasError = false;
      this.$http.post('/api/lawyerReq/init',{
        propertyId: this.B_TransferID,
        propertyType: this.propertyType, 
      }).then(res => {
        // console.log(res);
        this.isFree = res.data.isFree;
        this.lawyerPrice = res.data.price;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    sendChatMessage(){
      if(!this.CHAT_CLIENT){
        toast(this.$t('nav.relgoin'));
        return;
      }

      this.sendChatDisabled = true;
      this.$http.post('/api/chats/createChannel', {
        model: 'exchanges',
        id: parseInt(this.B_TransferID),
      }).then(({data}) => {
        if(data.newChat){
          const filter = {type: "messaging", cid: {$eq: `messaging:${data.channelId}`}};
          const sort = [{ last_message_at: -1 }];
          const options = {
            limit: 1, //watch: true,
          };
          this.CHAT_CLIENT.queryChannels(filter, sort, options).then(channel => {
            channel[0].sendMessage({
              text: this.$t('nav.welcome'),
            }).then(() => {
              this.sendChatDisabled = false;
              this.$router.push({path : '/chats', query: { id: data.channelId }});
            }).catch(err => {
              toast(this.$t('nav.chatCantSend'));
              this.sendChatDisabled = false;
            });
          }).catch(err => {
            toast(this.$t('nav.chatCantSend'));
            this.sendChatDisabled = false;
          });
        }else{
          this.sendChatDisabled = false;
          this.$router.push({path : '/chats', query: { id: data.channelId }});
        }
      }).catch(err => {
        const msg = this.$globalError(err);
        toast(msg);
        this.sendChatDisabled = false;
      });
    }
  },
  created(){
    this.getRetrieve();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>
